import styled from 'styled-components';

export const EmptyImageContainer = styled.div`
  border-radius: 6px;
  margin: 10px;
`;

export const EmptyImage = styled.img`
  border-radius: 6px;
  max-width: 98vw;
  object-fit: cover;
  height: auto;
  width: auto;
`;
